




























































import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import { CREATE_STATUS, AdgroupFormData, AssetItem, CampaignFormData } from '@tt4b/ttam-enums';
import { openPageByRouterName, PAGE_URLS, queryToJson } from '@tt4b/ttam-utils';
import { useSplitTestEnabled, useStdCampaignIs, useCreativeActionTypeIs, useCoupon } from '@tt4b/ttam-hooks';
import AssetBalanceAlert from './asset-balance-alert.vue';
import { CREATION_SUBMIT_ICON } from './const';
import SubmitSuccessHasCouponPng from '@tt4b/ttam-assets/src/images/creative/submit-success-has-coupon.png';

export default defineComponent({
  name: 'TtamCreativeNormalCreateSuccessDialog',
  components: {
    AssetBalanceAlert,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    createResultStatus: {
      type: Number as PropType<CREATE_STATUS>,
      required: true,
    },
    assetData: {
      type: Array as PropType<AssetItem[]>,
      default: () => [],
    },
    createMode: {
      type: String,
      default: 'create',
    },
  },
  setup(props, { emit }) {
    const { createResultStatus, adgroupData, campaignData, createMode } = toRefs(props);

    const { isSplitTestEnabled } = useSplitTestEnabled({ campaignData, adgroupData });

    /** 是否正在提交中 */
    const isSubmitting = computed(() => createResultStatus.value === CREATE_STATUS.SUBMITTING);

    /** 投放多个国家 */
    const isMultipleCountrySelected = computed(() => Boolean(adgroupData.value?.country?.length));

    function handleBackToList() {
      const { aadvid } = queryToJson();
      openPageByRouterName(PAGE_URLS.perfCreativeList, aadvid);
    }

    const CreateResultGif = computed(() =>
      isSubmitting.value ? CREATION_SUBMIT_ICON.SUBMITTING : CREATION_SUBMIT_ICON.SUCCESS,
    );
    const { isProductSalesCloseLoop } = useStdCampaignIs({
      campaignFormData: campaignData,
    });
    const { isCreate, isExistAdgroup } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const { showBudgetCoupon } = useCoupon();
    // 闭环下 adgroup budget 旁边展示coupon，creative 层（新建）提交时展示有coupon可用提示
    const showCreateAdCouponTitle = computed(
      () => isProductSalesCloseLoop.value && isCreate.value && !isExistAdgroup.value && showBudgetCoupon.value,
    );
    return {
      isSubmitting,
      isMultipleCountrySelected,
      handleBackToList,
      CreateResultGif,
      isSplitTestEnabled,
      showCreateAdCouponTitle,
      SubmitSuccessHasCouponPng,
    };
  },
});
